import {createStore} from "vuex";
import auth from "./modules/auth";
import messages from "./modules/messages";
import inboxs from "./modules/inbox";
import users from "./modules/users";
import conversations from "./modules/conversations";
import tickets from "./modules/tickets";



const store = createStore({

    state(){
       
    },
    modules:{
        auth,
        conversations,
        users,
        inboxs,
        messages,
        tickets,
    }
})

export default store